/* eslint-disable max-len */
import { renderToString } from "react-dom/server";

import dashboardFuelTypeErdgas from "../Images/dashboard-cards-icons/dashboard-fuel-type-1.svg";
import dashboardFuelTypeFlussiggas from "../Images/dashboard-cards-icons/dashboard-fuel-type-2.svg";
import dashboardFuelTypeHeizoil from "../Images/dashboard-cards-icons/dashboard-fuel-type-3.svg";
import dashboardFuelTypeFernwarme from "../Images/dashboard-cards-icons/dashboard-fuel-type-4.svg";

// import { ReactComponent as BuildingRatingChart1 } from "../Images/building-rating/building-rating-1.svg";
// import { ReactComponent as BuildingRatingChart2 } from "../Images/building-rating/building-rating-2.svg";
// import { ReactComponent as BuildingRatingChart3 } from "../Images/building-rating/building-rating-3.svg";
// import { ReactComponent as BuildingRatingChart4 } from "../Images/building-rating/building-rating-4.svg";
// import { ReactComponent as BuildingRatingChart5 } from "../Images/building-rating/building-rating-5.svg";
// import { ReactComponent as BuildingRatingChart6 } from "../Images/building-rating/building-rating-6.svg";
// import { ReactComponent as BuildingRatingChart7 } from "../Images/building-rating/building-rating-7.svg";
// import { ReactComponent as BuildingRatingChart8 } from "../Images/building-rating/building-rating-8.svg";
// import { ReactComponent as BuildingRatingChart9 } from "../Images/building-rating/building-rating-9.svg";
// import { ReactComponent as BuildingRatingChart10 } from "../Images/building-rating/building-rating-10.svg";

import { ReactComponent as BuildingRatingChart1 } from "../Images/building-rating/CO2-Einstufung_01.svg";
import { ReactComponent as BuildingRatingChart2 } from "../Images/building-rating/CO2-Einstufung_02.svg";
import { ReactComponent as BuildingRatingChart3 } from "../Images/building-rating/CO2-Einstufung_03.svg";
import { ReactComponent as BuildingRatingChart4 } from "../Images/building-rating/CO2-Einstufung_04.svg";
import { ReactComponent as BuildingRatingChart5 } from "../Images/building-rating/CO2-Einstufung_05.svg";
import { ReactComponent as BuildingRatingChart6 } from "../Images/building-rating/CO2-Einstufung_06.svg";
import { ReactComponent as BuildingRatingChart7 } from "../Images/building-rating/CO2-Einstufung_07.svg";
import { ReactComponent as BuildingRatingChart8 } from "../Images/building-rating/CO2-Einstufung_08.svg";
import { ReactComponent as BuildingRatingChart9 } from "../Images/building-rating/CO2-Einstufung_09.svg";
import { ReactComponent as BuildingRatingChart10 } from "../Images/building-rating/CO2-Einstufung_10.svg";

export const getDashboardFuelTypeIcon = (fuelType) => {
  switch (fuelType) {
    case "Erdgas":
      return dashboardFuelTypeErdgas;
    case "Flüssiggas":
      return dashboardFuelTypeFlussiggas;
    case "Heizöl":
      return dashboardFuelTypeHeizoil;
    case "Fernwärme":
      return dashboardFuelTypeFernwarme;
    default:
      return dashboardFuelTypeErdgas;
  }
};

export const calculateFuelConsumptionAmount = (
  fuelType,
  customEmission,
  customFernwarmeFactor = 0,
) => {
  let fuelConsumptionAmount = 0;

  switch (fuelType) {
    case "Erdgas":
      fuelConsumptionAmount = customEmission / (0.0036 * 0.0558);
      break;
    case "Flüssiggas":
      fuelConsumptionAmount = customEmission / (0.0036 * 0.0655);
      break;
    case "Heizöl":
      fuelConsumptionAmount = customEmission / (0.0036 * 0.0797);
      break;
    case "Fernwärme":
      fuelConsumptionAmount = customEmission / customFernwarmeFactor;
      break;
    default:
      fuelConsumptionAmount = 0;
  }

  fuelConsumptionAmount /= 1000;

  return fuelConsumptionAmount.toFixed(2);
};

export const calculateEmission = (
  fuelType,
  fuelConsumptionType,
  fuelConsumptionAmount,
  customFernwarmeFactor,
  customEmission,
) => {
  let emission = 0;

  const fernwarmeFactor = customFernwarmeFactor / 1000 / 1000 || 0.2553 / 1000;

  if (customEmission) {
    emission = customEmission;
  } else {
    switch (fuelType) {
      case "Erdgas":
        if (fuelConsumptionType === "kWh") {
          emission = fuelConsumptionAmount * 0.18139;
        } else {
          emission = fuelConsumptionAmount * 10 * 0.18139;
        }
        break;
      case "Flüssiggas":
        if (fuelConsumptionType === "kWh") {
          emission = fuelConsumptionAmount * 0.236;
        } else {
          emission = fuelConsumptionAmount * 6.77 * 0.236;
        }
        break;
      case "Heizöl":
        if (fuelConsumptionType === "kWh") {
          emission = fuelConsumptionAmount * 0.2664;
        } else {
          emission = fuelConsumptionAmount * 10.0461 * 0.2664;
        }
        break;
      case "Fernwärme":
        if (fuelConsumptionType === "kWh") {
          emission = fuelConsumptionAmount * fernwarmeFactor * 1000;
        } else {
          emission = fuelConsumptionAmount * 10 * fernwarmeFactor * 1000;
        }
        break;
      default:
        emission = 0;
    }
  }

  emission /= 1000;

  return {
    defaultEmission: parseFloat(emission.toFixed(6)),
    totalEmission: parseFloat(emission.toFixed(3)),
  };
};

export const calculateTenYearsCost = (
  forecastStartYear,
  defaultEmission,
  totalEmission,
  isCommercialProperty,
  isEnergyImprovementPossible,
  isSupplyImprovementPossible,
  livingSpace,
  co2Prices,
) => {
  let landlordPercentage = 0;
  let renterPercentage = 0;

  const emission = parseFloat(totalEmission).toFixed(3);
  const calculationEmission = parseFloat((totalEmission * 1000) / livingSpace).toFixed(3);

  switch (true) {
    case calculationEmission < 12:
      landlordPercentage = 0;
      renterPercentage = 1;
      break;
    case calculationEmission >= 12 && calculationEmission < 17:
      landlordPercentage = 0.1;
      renterPercentage = 0.9;
      break;
    case calculationEmission >= 17 && calculationEmission < 22:
      landlordPercentage = 0.2;
      renterPercentage = 0.8;
      break;
    case calculationEmission >= 22 && calculationEmission < 27:
      landlordPercentage = 0.3;
      renterPercentage = 0.7;
      break;
    case calculationEmission >= 27 && calculationEmission < 32:
      landlordPercentage = 0.4;
      renterPercentage = 0.6;
      break;
    case calculationEmission >= 32 && calculationEmission < 37:
      landlordPercentage = 0.5;
      renterPercentage = 0.5;
      break;
    case calculationEmission >= 37 && calculationEmission < 42:
      landlordPercentage = 0.6;
      renterPercentage = 0.4;
      break;
    case calculationEmission >= 42 && calculationEmission < 47:
      landlordPercentage = 0.7;
      renterPercentage = 0.3;
      break;
    case calculationEmission >= 47 && calculationEmission < 52:
      landlordPercentage = 0.8;
      renterPercentage = 0.2;
      break;
    case calculationEmission >= 52:
      landlordPercentage = 0.95;
      renterPercentage = 0.05;
      break;
    default:
      landlordPercentage = 0;
      renterPercentage = 0;
  }

  if (isCommercialProperty === 0) {
    if (isEnergyImprovementPossible === 1 && isSupplyImprovementPossible === 0) {
      landlordPercentage /= 2;
      renterPercentage = 1 - landlordPercentage;
    }
    if (isEnergyImprovementPossible === 0 && isSupplyImprovementPossible === 1) {
      landlordPercentage /= 2;
      renterPercentage = 1 - landlordPercentage;
    }
    if (isEnergyImprovementPossible === 0 && isSupplyImprovementPossible === 0) {
      landlordPercentage = 0;
      renterPercentage = 1;
    }
  } else {
    if (isEnergyImprovementPossible === 1 && isSupplyImprovementPossible === 1) {
      landlordPercentage = 0.5;
      renterPercentage = 0.5;
    }
    if (isEnergyImprovementPossible === 1 && isSupplyImprovementPossible === 0) {
      landlordPercentage = 0.25;
      renterPercentage = 0.75;
    }
    if (isEnergyImprovementPossible === 0 && isSupplyImprovementPossible === 1) {
      landlordPercentage = 0.25;
      renterPercentage = 0.75;
    }
    if (isEnergyImprovementPossible === 0 && isSupplyImprovementPossible === 0) {
      landlordPercentage = 0;
      renterPercentage = 1;
    }
  }

  let tenYearsCostAmount = 0;

  const forecast = [];

  // const currentYear = new Date().getFullYear();
  const currentYear = +forecastStartYear;

  for (let i = currentYear; i < currentYear + 10; i += 1) {
    const co2PriceForYear = co2Prices[i] || 55;
    const currentYearCosts = co2PriceForYear * emission;

    tenYearsCostAmount += currentYearCosts;

    forecast.push({
      year: i,
      totalAmount: currentYearCosts,
      totalAmountFormatted: Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
      }).format(currentYearCosts),
      landlordAmount: currentYearCosts * landlordPercentage,
      landlordAmountFormatted: Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
      }).format(currentYearCosts * landlordPercentage),
      renterAmount: currentYearCosts * renterPercentage,
      renterAmountFormatted: Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
      }).format(currentYearCosts * renterPercentage),
    });
  }
  return {
    forecast,
    totalAmount: tenYearsCostAmount,
    totalAmountFormatted: Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(
      tenYearsCostAmount,
    ),
    landlordPercentage: landlordPercentage * 100,
    landlordAmount: tenYearsCostAmount * landlordPercentage,
    landlordAmountFormatted: Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
    }).format(tenYearsCostAmount * landlordPercentage),
    renterPercentage: renterPercentage * 100,
    renterAmount: tenYearsCostAmount * renterPercentage,
    renterAmountFormatted: Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
    }).format(tenYearsCostAmount * renterPercentage),
  };
};

export const getBuildingRatingChart = (
  defaultEmission,
  totalEmission,
  isCommercialProperty,
  isEnergyImprovementPossible,
  isSupplyImprovementPossible,
  livingSpace,
) => {
  let buildingRatingChartComponent = null;

  const calculationEmission = parseFloat((totalEmission * 1000) / livingSpace).toFixed(3);

  switch (true) {
    case isEnergyImprovementPossible === 0 && isSupplyImprovementPossible === 0:
      buildingRatingChartComponent = <BuildingRatingChart1 width={982} />;
      break;
    case calculationEmission < 12:
      buildingRatingChartComponent = <BuildingRatingChart1 width={982} />;
      break;
    case calculationEmission >= 12 && calculationEmission < 17:
      buildingRatingChartComponent = <BuildingRatingChart2 width={982} />;
      break;
    case calculationEmission >= 17 && calculationEmission < 22:
      buildingRatingChartComponent = <BuildingRatingChart3 width={982} />;
      break;
    case calculationEmission >= 22 && calculationEmission < 27:
      buildingRatingChartComponent = <BuildingRatingChart4 width={982} />;
      break;
    case calculationEmission >= 27 && calculationEmission < 32:
      buildingRatingChartComponent = <BuildingRatingChart5 width={982} />;
      break;
    case calculationEmission >= 32 && calculationEmission < 37:
      buildingRatingChartComponent = <BuildingRatingChart6 width={982} />;
      break;
    case calculationEmission >= 37 && calculationEmission < 42:
      buildingRatingChartComponent = <BuildingRatingChart7 width={982} />;
      break;
    case calculationEmission >= 42 && calculationEmission < 47:
      buildingRatingChartComponent = <BuildingRatingChart8 width={982} />;
      break;
    case calculationEmission >= 47 && calculationEmission < 52:
      buildingRatingChartComponent = <BuildingRatingChart9 width={982} />;
      break;
    case calculationEmission >= 52:
      buildingRatingChartComponent = <BuildingRatingChart10 width={982} />;
      break;
    default:
      buildingRatingChartComponent = null;
  }

  const buildingRatingChart = renderToString(buildingRatingChartComponent)
    .replace(/&amp;gt;/gi, ">")
    .replace(/&amp;lt;/gi, "<");

  return buildingRatingChart;
};
